(function () {
    var timeTemplate =     
    '{{#each (item, idx) in timeTable}}'+
        '<div class="filter-group">'+
            '<div class="tit-wrap">'+
                '{{#if idx === 0}}'+
                    '<strong class="tit">오전</strong>'+
                '{{#else}}'+
                    '<strong class="tit">오후</strong>'+
                '{{/if}}'+
            '</div>'+
            '<div class="flex-chk-wrap">'+
                '{{#each listItem in item}}'+
                    '<div class="chk-wrap">'+
                        '<input type="radio" name="tcr-rdo2" id="tcr-rdo2-{{listItem.idx}}" {{#if listItem.disabled}}disabled{{/if}}>'+
                        '<label for="tcr-rdo2-{{listItem.idx}}">'+
                            '{{#if listItem.disabled}}<span class="blind">선택할 수 없음</span>{{/if}}'+
                            '{{listItem.time}}'+
                        '</label>'+
                    '</div>'+
                '{{/each}}'+
            '</div>'+
        '</div>'+
    '{{/each}}';

    var register = {
        selectDate:{
            required: true,
            errorMsg:"연락처를 입력해 주세요."
        },
        selectTime:{
            required: true,
            errorMsg:"연락처를 입력해 주세요."
        },
    }
  
    var consultReservePopup ={
        /*
         * [CSR-11579] 구매상담예약 영역 공통화
         * - 기본(window팝업): init() — 기존 동작 유지 (.tel-counsel-popup 자동 스코프)
         * - embed(타 셀 include): lgkorConsultReserve.init(options)
         *   options.container      : 공통 fragment(.tel-counsel-content)를 감싼 요소 (필수)
         *   options.reserveButton  : 예약 트리거 버튼 (선택, 활성/비활성 자동 관리)
         *   options.onComplete(no) : 예약 성공 콜백 (미지정 시 안내 alert만)
         *   options.onDowntime(d)  : 시스템 점검 콜백
         *   options.onFail()       : 예약 실패 콜백
         *   options.onValidChange(isValid) : 필수값 충족 여부 변경 콜백
         * - 공개 메서드: lgkorConsultReserve.reserve() 예약 실행 / lgkorConsultReserve.isValid() 필수값 충족 여부
         *
         * [CSR-17021] 구독기획전(gubun=L) 공통 랜딩 URL 대응 (window팝업 모드)
         * - 비로그인 진입(data-loginFlag=N) 시 로그인 유도 후 현재 팝업 URL로 복귀
         * - window.open 없이 열린 창(링크 직접 진입, target=_blank)에서도 닫기/완료 이동이 동작하도록 opener 가드
         * - L은 구독 계열로 처리(완료 메시지·GA), data-eventName을 예약 등록 API에 전달
         */
        init: function(options) {
            var self = this;
            self.options = options || {};

            vcui.require(['ui/validation', 'ui/calendarTable'], function () {
                self.setting();
                self.bindEvents();
            });
        },

        setting: function() {
            var self = this;
            self.options = self.options || {};
            self.isEmbed = !!self.options.container; // CSR-11579 embed 모드 여부
            self.$popup = self.isEmbed ? $(self.options.container) : $('.tel-counsel-popup');
            self.$telCounselContent = self.$popup.hasClass('tel-counsel-content') ? self.$popup : self.$popup.find('.tel-counsel-content');
            self.$calendarWrap = self.$telCounselContent.find('.calendar-wrap');
            self.$timetableWrap = self.$telCounselContent.find('.timetable-wrap');
            self.$hiddenInputGroup = self.$telCounselContent.find('.hidden-input-group');
            self.$reserveButton = self.options.reserveButton ? $(self.options.reserveButton) : self.$popup.find('button[data-role="ok"]');
            self.reserving = false;
            self.registValidation = null;

            // embed: 필수값 검증 전까지 예약 버튼 비활성화 (window팝업은 마크업에서 disabled로 시작)
            if (self.isEmbed) {
                self.$reserveButton.prop('disabled', true);
            }

            // [CSR-17021] window팝업 모드: 비로그인 상태로 공통 URL 직접 진입 시 로그인 유도 (embed는 호출 셀에서 처리)
            if (!self.isEmbed && self.$telCounselContent.attr('data-loginFlag') === 'N') {
                self._requireLogin();
                return;
            }

            // data-contents 설정 (GA) - window팝업 전용 (embed는 호출 셀에서 GA 처리)
            if (!self.isEmbed) {
                var gubun = self.$telCounselContent.attr('data-gubun');
                var productName = self.$telCounselContent.attr('data-productName');
                var eventName = self.$telCounselContent.attr('data-eventName'); // [CSR-17021] 구독기획전명
                var $reserveButton = self.$reserveButton;
                if (gubun === 'C') {
                    $reserveButton.attr('data-contents', 'PDP구독-'+productName);
                } else if (gubun === 'J') {
                    $reserveButton.attr('data-contents', 'PDP일시불-'+productName);
                } else if (gubun === 'L') {
                    $reserveButton.attr('data-contents', '구독기획전-' + (eventName || '구독기획전')); // [CSR-17021]
                } else {
                    $reserveButton.attr('data-contents', '웨딩/혼수 기획전');
                }
            }

            if (self.$calendarWrap.attr('ui-modules')) {
                self.$calendarWrap.vcCalendarTable({"inputTarget":self.$hiddenInputGroup.find('input[name="selectDate"]'),"formatPad0":true});
            }

            self._setCalendarTable();
            self.registValidation = new vcui.ui.Validation(self.$popup[0], {register:register});
        },

        handler: {
            click: function(e) {
                var self = this;
                var $target = $(e.target);

                // 닫기 버튼 클릭 시
                if ($target.closest('.win-btn-close').length) {
                    self._closePopup(); // [CSR-17021] opener 없는 창(직접 진입) 대응
                }

                // 예약하기 버튼 클릭 시
                if ($target.closest('.btn.ui_modal_close[data-role="ok"]').length) {
                    self.handler.reserve.call(self);
                }
            },
            change: function(e) {
                var self = this;
                var $target = $(e.target);

                // 상담 목적 change 시
                if ($target.closest('.tel-counsel-filter').length) {
                    var $listWrap = $target.closest('.flex-chk-wrap');
                    var $contWrap = $target.closest('.tel-counsel-content');
                    var $inputWrap = $target.closest('.chk-wrap');
        
                    if ($target.closest('.timetable-wrap').length) return;
        
                    $listWrap.find('.blind').remove();
                    $inputWrap.find('label').prepend('<span class="blind">선택됨</span>');
                    $listWrap.find('input[disabled]').next('label').prepend('<span class="blind">선택할 수 없음</span>');
                    //self._setCalendarTable();
                }
                
                // 상담 시간 change 시
                if ($target.closest('.timetable-wrap').length) {
                    var $listWrap = $target.closest('.timetable-wrap');
                    var $inputWrap = $target.closest('.chk-wrap');                    
        
                    $listWrap.find('.blind').remove();
                    $inputWrap.find('label').prepend('<span class="blind">선택됨</span>');
                    $listWrap.find('input[disabled]').next('label').prepend('<span class="blind">선택할 수 없음</span>');
                    self.$hiddenInputGroup.find('input[name=selectTime]').val(
                        $target.closest('.chk-wrap').find('label').contents().filter(function() {
                            return this.nodeType === 3; // 텍스트 노드만 선택
                        }).text().trim().replace(':', '')
                    );
                }
                // 모든 값 확인 후 버튼 활성화
                self._updateReserveButtonState();
            },
            reserve: function() {
                var self = this;

                if (self.reserving) return; // 중복 제출 방지

                // 유효성 검사 (버튼 활성화로 변경)
                var selectPurpose = self.$popup.find('input[name="tcr-rdo1"]:checked').val();
                var selectDate = self.$hiddenInputGroup.find('input[name="selectDate"]').val();
                var selectTime = self.$hiddenInputGroup.find('input[name="selectTime"]').val();
                var quickContactFlag = self.$popup.find('input[name="tcr-chk1"]').is(':checked') ? 'Y' : 'N';
                var gubun = self.$telCounselContent.attr('data-gubun');
                var sku = self.$telCounselContent.attr('data-sku');
                var modelId = self.$telCounselContent.attr('data-modelId');
                var categoryId = self.$telCounselContent.attr('data-categoryId');
                var subCategoryId = self.$telCounselContent.attr('data-subCategoryId');
                var eventName = self.$telCounselContent.attr('data-eventName'); // [CSR-17021] 구독기획전(L) 기획전명

                if (self.isEmbed && !(selectDate && selectTime && (gubun === 'C' || selectPurpose))) {
                    return; // embed는 호출 셀 버튼 상태와 무관하게 자체 검증
                }

                self.reserving = true;

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/consult/reserve/create", {
                    method: "POST",
                    contentType: "application/json",
                    data: JSON.stringify({
                        consultDate: selectDate,
                        consultTime: selectTime,
                        consultPurpose: selectPurpose,
                        message: self.$popup.find('textarea[name="content"]').val(),
                        gubun: gubun,
                        modelId: modelId,
                        modelName: sku,
                        categoryId: categoryId,
                        subCategoryId: subCategoryId,
                        quickContactFlag: quickContactFlag,
                        eventName: eventName // [CSR-17021] 구독기획전(L) 전용, 그 외 구분은 서버에서 미사용
                    }),
                    success: function(result) {
                        self.reserving = false;
                        if (result.message == "Created" && result.data) {
                            // 예약 성공 시
                            if (typeof self.options.onComplete === 'function') {
                                self.options.onComplete(result.data);
                                return;
                            }
                            if (self.isEmbed) {
                                lgkorUI.alert('상담예약이 완료되었습니다.');
                                return;
                            }
                            var confirmMessage = (gubun === 'C' || gubun === 'L') // [CSR-17021] 구독기획전(L)도 구독 계열
                                ? '구독상담예약이 완료되었습니다.<br>예약하신 내용을 확인하시겠습니까?'
                                : '구매상담예약이 완료되었습니다.<br>예약하신 내용을 확인하시겠습니까?';
                            var isSubscribe = (gubun === 'C' || gubun === 'L'); // 구독(PDP), 구독기획전
                            var pdpType = isSubscribe ? 'SUBSCRIPTION' : 'PURCHASE';
                            var reserveType = isSubscribe ? 'subscribe' : 'purchase';
                            var statusUrl = '/support/service-inquiry-reservation-status/single?number=' + result.data
                                + '&modelId=' + modelId
                                + '&pdpType=' + pdpType
                                + '&reserveType=' + reserveType; // 예약 완료 화면

                            lgkorUI.confirm(confirmMessage, {
                                ok: function() {
                                    // [CSR-17021] window.open으로 열린 팝업은 부모창 이동 후 닫고, opener가 없으면(공통 URL 직접 진입) 현재 창에서 이동
                                    if (window.opener && !window.opener.closed) {
                                        window.opener.location.href = statusUrl;
                                        window.close();
                                    } else {
                                        location.href = statusUrl;
                                    }
                                },
                                cancel: function() {
                                    self._closePopup();
                                }
                            });
                        } else if (result.data && result.data.active === true) {
                            // 다운타임 인 경우
                            var downTime = result.data.downTime; // 점검 시작 시간
                            var openTime = result.data.openTime; // 점검 종료 시간
                            if (typeof self.options.onDowntime === 'function') {
                                self.options.onDowntime(result.data);
                                return;
                            }
                            lgkorUI.alert(
                                '더 나은 서비스 환경을 위해 시스템을 점검하고 있습니다.<br>' +
                                '신속하게 점검 중이오니 조금만 기다려주시기 바랍니다.<br><br>' +
                                '점검 시간: ' + downTime + ' ~ ' + openTime,
                                self.isEmbed ? undefined : {
                                    ok: function() {
                                        self._closePopup(); // [CSR-17021] opener 없는 창 대응
                                    }
                                }
                            );
                        } else {
                            // 예약 실패 시
                            if (typeof self.options.onFail === 'function') {
                                self.options.onFail();
                                return;
                            }
                            lgkorUI.alert('예약에 실패하였습니다. 다시 시도해 주세요.', self.isEmbed ? undefined : {
                                ok: function() {
                                    location.reload(); // 페이지 새로고침
                                }
                            });
                        }
                    },
                    error: function(jqXHR) {
                        // 예약 실패 시
                        self.reserving = false;
                        if (typeof self.options.onFail === 'function') {
                            self.options.onFail();
                            return;
                        }
                        lgkorUI.alert('예약에 실패하였습니다. 다시 시도해 주세요.', self.isEmbed ? undefined : {
                            ok: function() {
                                location.reload(); // 페이지 새로고침
                            }
                        });
                    }
                });
            },
            dateselected: function(e) { // 달력 날짜 선택 이벤트
                var self = this;
                var $td = self.$calendarWrap.find('tr td.choice');

                // 선택된 날짜 가져오기
                var year = $td.data('year'); // data-year 값
                var month = String($td.data('month')).padStart(2, '0'); // data-month 값 (2자리로 패딩)
                var day = String($td.data('day')).padStart(2, '0');
                var selectedDate = year + month + day;
                if (selectedDate) {
                    self.$hiddenInputGroup.find('input[name="selectDate"]').val(selectedDate);
                    //console.log('선택된 날짜:', selectedDate); // 디버깅용 로그
                } else {
                    console.error('선택된 날짜를 가져올 수 없습니다.');
                }

                self.$calendarWrap.find('.tb-calendar .blind').remove();
                $td.find('button').prepend('<span class="blind">선택됨</span>');
                self.$calendarWrap.find('td.disabled button').prepend('<span class="blind">선택할 수 없음</span>');
                self._setTimeTable(selectedDate,self.$telCounselContent.attr('data-gubun'));

                // selectTime 초기화
                self.$hiddenInputGroup.find('input[name="selectTime"]').val('');

                // 모든 값 확인 후 버튼 활성화
                self._updateReserveButtonState();
            },
            daterender: function(e) { // 달력 dom 랜더 완료 이벤트
                var self = this;
                var $td = self.$calendarWrap.find('tr td.choice');
                var $disabledBtn = self.$calendarWrap.find('td.disabled button');
    
                if ($td.length) {
                    $td.find('.tb-calendar .blind').remove();
                    $td.find('button').prepend('<span class="blind">선택됨</span>');
                }
                
                $disabledBtn.prepend('<span class="blind">선택할 수 없음</span>');
                $disabledBtn.attr('disabled', 'disabled');
            }
        },

        bindEvents: function() {
            var self = this;
            self.handler.click = self.handler.click.bind(self);
            self.handler.change = self.handler.change.bind(self);
            self.handler.dateselected = self.handler.dateselected.bind(self);
            self.handler.daterender = self.handler.daterender.bind(self);

            // 네임스페이스 바인딩: embed에서 fragment 재주입 후 재-init해도 핸들러가 중복 부착되지 않도록
            self.$popup.off('click.consultReserve change.consultReserve');
            self.$popup.on('click.consultReserve', self.handler.click);
            self.$popup.on('change.consultReserve', self.handler.change);

            // embed 모드: 호출 셀이 제공한 예약 버튼에 직접 바인딩 (window팝업은 delegate로 처리)
            if (self.isEmbed && self.options.reserveButton) {
                self.$reserveButton.off('click.consultReserve').on('click.consultReserve', function() {
                    self.handler.reserve.call(self);
                });
            }

            self.$calendarWrap.on('dateselected', self.handler.dateselected);
            self.$calendarWrap.on('daterender', self.handler.daterender);
        },

        // [CSR-11579] embed 호출 셀에서 직접 사용할 수 있는 공개 메서드
        reserve: function() {
            this.handler.reserve.call(this);
        },

        isValid: function() {
            var self = this;
            var selectPurpose = self.$popup.find('input[name="tcr-rdo1"]:checked').val();
            var selectDate = self.$hiddenInputGroup.find('input[name="selectDate"]').val();
            var selectTime = self.$hiddenInputGroup.find('input[name="selectTime"]').val();
            var gubun = self.$telCounselContent.attr('data-gubun');

            return !!(selectDate && selectTime && (gubun === 'C' || selectPurpose));
        },

        _updateReserveButtonState: function() {
            var self = this;

            var isValid = self.isValid();

            if (typeof self.options.onValidChange === 'function') {
                self.options.onValidChange(isValid);
            }

            if (self.isEmbed) {
                self.$reserveButton.prop('disabled', !isValid);
                return;
            }

            var $reserveButton = self.$reserveButton;

            // 예약 데이터 검증 로직 추가
            if (isValid) {
                $reserveButton.prop('disabled', false); // 버튼 활성화

                // 기존 이벤트 제거 후 다시 바인딩
                $reserveButton.off('click').on('click', function() {
                    $reserveButton.prop('disabled', true); // 클릭 후 버튼 비활성화
                    //self.handler.reserve.call(self); // 예약 처리
                });
            } else {
                $reserveButton.prop('disabled', true); // 버튼 비활성화
                $reserveButton.off('click'); // 기존 이벤트 제거
            }
        },

        // [CSR-17021] 비로그인 진입 시 로그인 유도 (로그인 후 현재 팝업 URL로 복귀)
        _requireLogin: function() {
            var self = this;
            var returnUrl = location.pathname + location.search;

            lgkorUI.confirm('', {
                title: '상담 예약을 위해 로그인이 필요해요.',
                okBtnName: '로그인 하기',
                cancelBtnName: '취소',
                ok: function() {
                    location.href = '/sso/member/login?state=' + encodeURIComponent(returnUrl);
                },
                cancel: function() {
                    self._closePopup();
                }
            });
        },

        // [CSR-17021] 팝업 닫기 — window.open으로 열리지 않은 창(링크 직접 진입, target=_blank noopener)은 close()가 무시되므로 이전 페이지/홈으로 이동
        _closePopup: function() {
            window.close();
            setTimeout(function() {
                if (window.closed) return;
                if (history.length > 1) {
                    history.back();
                } else {
                    location.href = '/';
                }
            }, 300);
        },

        // 캘린더 set
        _setCalendarTable: function() {
            var self = this;

            // 초기화: 빈 배열로 캘린더 표시
            self.$calendarWrap.vcCalendarTable('update', []);
            self.$calendarWrap.find('td.disabled button').attr('disabled', 'disabled');

            //구매상담예약 가능날짜 조회
            lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/consult/reserve/date-list", {
                method: "GET",
                data: {
                    dayCnt: 14, //14일
                    gubun: self.$telCounselContent.attr('data-gubun') // [CSR-20547] 구독(C)·구독기획전(L)은 토요일 포함·휴무일 제외·당일 마감 18:30 을 서버가 구분별로 판정
                },
                success: function(result) {
                    var dateList = [];
                    if (result.data && result.data.listData) {
                        // listData에서 consultDate 추출하여 dateList 생성
                        dateList = result.data.listData.map(function(item) {
                            return item.consultDate;
                        });
                    }
                    // 캘린더 업데이트
                    self.$calendarWrap.vcCalendarTable('update', dateList);
                    self.$calendarWrap.find('td.disabled button').attr('disabled', 'disabled');
                    //self._setTimeTable();

                    // 가장 첫 번째 날짜 선택
                    if (dateList.length > 0) {

                        self._setEarliestAvailable(dateList, self.$telCounselContent.attr('data-gubun'));

                        var firstDate = dateList[0];
                        var year = firstDate.substring(0, 4); // "2025"
                        var month = parseInt(firstDate.substring(4, 6), 10); // 8
                        var day = parseInt(firstDate.substring(6, 8), 10); // 1

                        var $td = self.$calendarWrap.find('td[data-year="' + year + '"][data-month="' + month + '"][data-day="' + day + '"]');

                        if ($td.length > 0) {
                            // 특정 날짜 td에 choice 클래스 추가
                            $td.addClass('choice');
                            // dateselected 호출
                            self.handler.dateselected.call(self);
                        }
                    }
                },
                error: function(jqXHR) {
                    console.log(jqXHR);
                }
            });
        },

        // [S] BTOCSITE-106954 구매 상담예약 기능 개선
        _setEarliestAvailable: function (dateList, gubun) {
            var self = this;
            var dayNames = ['일', '월', '화', '수', '목', '금', '토'];
        
            function formatEarliestText(date, slot) {
                var d = new Date(date.substring(0, 4), date.substring(4, 6) - 1, date.substring(6, 8));
                var dayText = date.substring(4, 6) + "월 " + date.substring(6, 8) + "일(" + dayNames[d.getDay()] + ")";
                var h = parseInt(slot.consultTime.substring(0, 2), 10);
                var m = slot.consultTime.substring(2);
                var period = h < 12 ? '오전' : '오후';
                var hh = h > 12 ? h - 12 : h;
                var timeText = period + " " + String(hh).padStart(2, '0') + "시 " + m + "분";
                return { d, dayText, timeText };
            }
        
            function tryDay(i) {
                if (i >= dateList.length) {
                    // if all have been checked and no slot is found
                    return;
                }
        
                var date = dateList[i];
                var timeTable = [];
                var startTime = 1000; 
                var endTime = 1630;
                var timeInterval = 30;
        
                while (startTime <= endTime) {
                    timeTable.push(String(startTime).padStart(4, '0'));

                    var minutes = startTime % 100;
                    var hours = Math.floor(startTime / 100);
    
                    minutes += timeInterval;
                    if (minutes >= 60) {
                        minutes -= 60;
                        hours += 1;
                    }
    
                    startTime = hours * 100 + minutes;
                }

                lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/consult/reserve/time-list", {
                    method: "GET",
                    data: { consultDate: date, gubun: gubun },
                    success: function (res) {
                        var capa = res.data.capaCount;

                        var listDataFiltered = res.data.listData.filter(function (item) {
                            return timeTable.includes(item.consultTime);
                        });

                        // [CSR-20547] 구독(C)·구독기획전(L)은 서버가 슬롯 목록(추가 슬롯 12:00/12:30/17:00~18:30, 토요일 포함)과 슬롯별 가능여부(availableYn)를 내려주므로 그대로 사용
                        var slot;
                        if (consultReservePopup._isSlotPolicyResponse(res.data.listData)) {
                            slot = res.data.listData.find(function (s) {
                                return s.availableYn === 'Y';
                            });
                        } else {
                            slot = Array.isArray(listDataFiltered)
                            ? listDataFiltered.find(function (s) {
                                return s.timeDisplayYn === 'Y' && s.consultTimeCnt < capa;
                            })
                            : null;
                        }

                        if (slot) {
                            var t = formatEarliestText(date, slot);
                        
                            let dayTimeText = t.dayText + " " + t.timeText;
                            let newTxtInfoContent =    `<p class="txt-info">현재 예약 가능한 가장 빠른 시간은<br><strong class="c-primary">${dayTimeText}</strong> 입니다.</p>`;
                            self.$popup.find('.txt-info').html(newTxtInfoContent);
                            // STOP completely: do not call the next date
                            return;
                        }
        
                        // No slot → try next date
                        tryDay(i + 1);
                    },
                    error: function () {
                        // If the current date has an error or no available slots, move on to check the next date
                        tryDay(i + 1);
                    }
                });
            }
        
            // Start sequentially from the first date
            tryDay(0);
        },
        // [E] BTOCSITE-106954 구매 상담예약 기능 개선

        // [CSR-20547] 서버 슬롯 정책 응답 여부 — 구독(C)·구독기획전(L)만 행마다 capa(슬롯 CAPA)·availableYn 이 내려온다. J/K 는 null
        _isSlotPolicyResponse: function(listData) {
            return Array.isArray(listData) && listData.length > 0 && listData[0].capa !== null && listData[0].capa !== undefined;
        },

        // 시간 set
        _setTimeTable: function(consultDate, gubun) {
            var self = this;

            var timeTable = [];
            var startTime = 1000; // 시작 시간
            var endTime = 1630;  // 종료 시간
            var timeInterval = 30; // 시간 간격 (30분 단위) //시간 간격 10,20,30분 변경될 수 있음 (추후 공통코드로?)

            while (startTime <= endTime) {
                timeTable.push({ time: String(startTime).padStart(4, '0'), disabled: true });

                // 시간 간격에 따라 증가
                var minutes = startTime % 100;
                var hours = Math.floor(startTime / 100);

                minutes += timeInterval;
                if (minutes >= 60) {
                    minutes -= 60;
                    hours += 1;
                }

                startTime = hours * 100 + minutes; // HHMM 형식으로 업데이트
            }

            //구매상담예약 가능시간 조회
            lgkorUI.requestKongAjax("itemsvc", "/ajax/v1/consult/reserve/time-list", {
                method: "GET",
                data: {
                    consultDate: consultDate,
                    gubun: gubun

                },
                success: function(result) {
                    var $filterGroupWrap = self.$timetableWrap.find('.filter-group-wrap');
                    var $noTimeMessage = self.$timetableWrap.find('.bx-timetable-none');
                    var $newFormStyle = self.$telCounselContent.find('.new-form-style');

                    if (result.data && result.data.listData) {
                        var ajaxData = result.data.listData;
                        // [CSR-20547] 구독(C)·구독기획전(L): 서버 슬롯 정책 응답(슬롯별 capa/availableYn)이면 응답 행을 그대로 그리드로 사용
                        //   → 평일 추가 슬롯(12:00/12:30/17:00~18:30)·토요일 슬롯이 노출되고, 점심시간 제외도 서버 슬롯 목록(capa > 0 행)을 따른다
                        //   일반(J)·기획전(K)은 capa 가 없으므로 기존 10:00~16:30 30분 그리드 + capaCount 판정 유지
                        var isSlotPolicy = self._isSlotPolicyResponse(ajaxData);

                        if (isSlotPolicy) {
                            // 응답에는 10분 단위 전체 행이 내려오며 정책 슬롯이 아닌 행(13:00대·10분 단위·운영 중단 묶음)은 capa 0 → 그리드에서 제외
                            timeTable = ajaxData.filter(function(data) {
                                return data.capa > 0;
                            }).sort(function(a, b) {
                                return a.consultTime.localeCompare(b.consultTime); // HHmm 문자열 시각순
                            }).map(function(data) {
                                return { time: data.consultTime, disabled: data.availableYn !== 'Y' };
                            });
                        } else {
                            timeTable = timeTable.map(function(item) {
                                var matchedData = ajaxData.find(function(data) {
                                    return data.consultTime === item.time;
                                });
                                if (matchedData) {
                                    var consultTimeLimit = result.data.capaCount; //CAPA 수 셋팅
                                    item.disabled = !(matchedData.consultTimeCnt < consultTimeLimit && matchedData.timeDisplayYn === 'Y');
                                }
                                return item;
                            });
                        }

                        var hasAvailableTime = timeTable.some(function(item) {
                            return !item.disabled; // 사용 가능한 시간이 있는지 확인
                        });

                        if (hasAvailableTime) {
                            $filterGroupWrap.show(); // 시간 목록 표시
                            $newFormStyle.show(); // 체크박스 표시
                            $noTimeMessage.hide();  // 시간 없음 메시지 숨김
                        } else {
                            $filterGroupWrap.hide(); // 시간 목록 숨김
                            $newFormStyle.hide(); // 체크박스 표시
                            $noTimeMessage.show();  // 시간 없음 메시지 표시
                        }

                        timeTable = timeTable.reduce(function(result, item, idx) {
                            var hours = parseInt(item.time.substring(0, 2), 10);
                            var minutes = parseInt(item.time.substring(2, 4), 10);
                            var totalTime = hours * 100 + minutes;

                            // 점심시간 제외는 기존 그리드(J·K)에만 적용 — 슬롯 정책 응답(C·L)은 서버가 운영 슬롯만 내려준다 [CSR-20547]
                            if (!isSlotPolicy && totalTime >= 1200 && totalTime <= 1330) {
                                return result;
                            }

                            item.idx = idx + 1;
                            item.time = item.time.replace(/(\d{2})(\d{2})/, "$1:$2");

                            if (hours < 12) {
                                result[0].push(item); // 오전
                            } else {
                                result[1].push(item); // 오후
                            }

                            return result;
                        }, [[], []]);

                        self.$timetableWrap.find('.filter-group-wrap').html(vcui.template(timeTemplate, { 'timeTable': timeTable }));
                        self.$hiddenInputGroup.find('input[name=selectTime]').val('');
                    }
                },
                error: function(jqXHR) {
                    console.log(jqXHR);
                }
            });

        }
    }

    // [CSR-11579] embed(타 셀 include)용 공개 인터페이스
    window.lgkorConsultReserve = consultReservePopup;

    $(function () {
        // window팝업 페이지에서만 자동 초기화 (embed는 호출 셀이 lgkorConsultReserve.init() 직접 호출)
        if ($('.tel-counsel-popup').length) {
            consultReservePopup.init();
        }
    });
})();